"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvironmentOut = void 0;
class EnvironmentOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EnvironmentOut.attributeTypeMap;
    }
}
exports.EnvironmentOut = EnvironmentOut;
EnvironmentOut.discriminator = undefined;
EnvironmentOut.attributeTypeMap = [
    {
        "name": "createdAt",
        "baseName": "createdAt",
        "type": "Date",
        "format": "date-time"
    },
    {
        "name": "eventTypes",
        "baseName": "eventTypes",
        "type": "Array<EventTypeOut>",
        "format": ""
    },
    {
        "name": "settings",
        "baseName": "settings",
        "type": "SettingsOut",
        "format": ""
    },
    {
        "name": "version",
        "baseName": "version",
        "type": "number",
        "format": "int"
    }
];
//# sourceMappingURL=EnvironmentOut.js.map